var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosShareIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.75C4.75736 9.75 3.75 10.7574 3.75 12C3.75 13.2426 4.75736 14.25 6 14.25C7.24264 14.25 8.25 13.2426 8.25 12C8.25 10.7574 7.24264 9.75 6 9.75ZM2.25 12C2.25 9.92893 3.92893 8.25 6 8.25C8.07107 8.25 9.75 9.92893 9.75 12C9.75 14.0711 8.07107 15.75 6 15.75C3.92893 15.75 2.25 14.0711 2.25 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 16.5C15.2574 16.5 14.25 17.5074 14.25 18.75C14.25 19.9926 15.2574 21 16.5 21C17.7426 21 18.75 19.9926 18.75 18.75C18.75 17.5074 17.7426 16.5 16.5 16.5ZM12.75 18.75C12.75 16.6789 14.4289 15 16.5 15C18.5711 15 20.25 16.6789 20.25 18.75C20.25 20.8211 18.5711 22.5 16.5 22.5C14.4289 22.5 12.75 20.8211 12.75 18.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 3C15.2574 3 14.25 4.00736 14.25 5.25C14.25 6.49264 15.2574 7.5 16.5 7.5C17.7426 7.5 18.75 6.49264 18.75 5.25C18.75 4.00736 17.7426 3 16.5 3ZM12.75 5.25C12.75 3.17893 14.4289 1.5 16.5 1.5C18.5711 1.5 20.25 3.17893 20.25 5.25C20.25 7.32107 18.5711 9 16.5 9C14.4289 9 12.75 7.32107 12.75 5.25Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.609 6.46646C14.833 6.81493 14.732 7.27894 14.3835 7.50287L8.92728 11.0091C8.57881 11.2331 8.11479 11.1321 7.89087 10.7836C7.66694 10.4352 7.7679 9.97114 8.11636 9.74721L13.5726 6.24096C13.9211 6.01703 14.3851 6.11799 14.609 6.46646Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89087 13.2165C8.11479 12.868 8.57881 12.767 8.92728 12.991L14.3835 16.4972C14.732 16.7211 14.833 17.1852 14.609 17.5336C14.3851 17.8821 13.9211 17.983 13.5726 17.7591L8.11636 14.2529C7.7679 14.0289 7.66694 13.5649 7.89087 13.2165Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosShareIconBlack);
export default __webpack_public_path__ + "static/media/IosShareIconBlack.fa4a63388f5c80c1faaf37d83b022d4f.svg";
export { ForwardRef as ReactComponent };